"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TabList = require("./TabList");
Object.keys(_TabList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TabList[key];
    }
  });
});